import { useEffect } from "react";
import { isStoreHost } from "@/store/nav";
import { replaceRobotsMeta } from "@/store/seo/robots";

const productionHost = "ulico-internal-ops.emergent.host";
const previewHostSuffix = ".preview.emergentagent.com";
const releaseLabel = "safety-contract-v1";

export const clientEnvironment = () => {
  const hostname = window.location.hostname.toLowerCase();
  if (hostname === productionHost) {
    return "production";
  }
  if (hostname.endsWith(previewHostSuffix)) {
    return "preview";
  }
  return "unconfigured";
};

export const EnvironmentRibbon = () => {
  const environment = clientEnvironment();
  const isPreview = environment === "preview";
  const isProduction = environment === "production";
  useEffect(() => {
    const isStoreRoute = isStoreHost || window.location.pathname.startsWith("/store");
    if (isStoreRoute) return;
    replaceRobotsMeta("noindex, nofollow, noarchive");
    const environmentName = isProduction
      ? "Producción"
      : isPreview
        ? "Pruebas"
        : "Sin configurar";
    document.title = `${environmentName} · OWLICO`;
  }, [isPreview, isProduction]);

  if (isProduction || isStoreHost) {
    return null;
  }

  const label = isPreview ? "ENTORNO DE PRUEBAS · PREVIEW" : "ENTORNO SIN CONFIGURAR";
  return (
    <div className="environment-ribbon" data-testid="environment-ribbon">
      <span data-testid="environment-ribbon-label">{label}</span>
      <span className="environment-ribbon-release" data-testid="environment-ribbon-release">
        {releaseLabel || "release sin etiqueta"}
      </span>
    </div>
  );
};